import { CFSSystemDetailCardBase } from './CFSSystemDetailCardBase';
import { SystemCardBaseProps } from '../base-card-common/SystemCardBase';

export const CFSSystemDetailCard = (props: SystemCardBaseProps) => {
  const { boldLabelTitles = false } = props;
  return (
    <CFSSystemDetailCardBase {...props} boldLabelTitles={boldLabelTitles} />
  );
};
